import { useMemo, memo } from 'react';
import { FilterValue } from 'components/filtering/types/FilterObject';
import { CheckTypeEnum } from 'components/filtering/types/CheckTypeEnum';
import FilterResultItem from 'components/filtering/filter-popover/result/FilterResultItem';
import CheckboxToggleAll from 'components/filtering/filter-popover/result/CheckboxToggleAll';
import CheckboxAddToFilter from 'components/filtering/filter-popover/result/CheckboxAddToFilter';



interface FilterResultProps {
	filterValues: FilterValue[],
	valuesCheckType: CheckTypeEnum,
	addToFilter: boolean,
	showAddToFilter: boolean,
	onToggleAll: () => void,
	onAddToFilter: () => void,
	onToggle: (checkedValues: unknown[]) => void,
}


const FilterResult = (props: FilterResultProps) => {
	const { filterValues, valuesCheckType, addToFilter, showAddToFilter, onToggleAll, onAddToFilter, onToggle } = props;


	const [ sortedAndFilteredFilterValues, firstNullValue ] = useMemo((): [ FilterValue[], FilterValue | null ] => {
		if (!filterValues || filterValues.length === 0) return [ [], null ];
		
		let firstNullValue: FilterValue | null = null;
		let filteredFilterValues = filterValues.filter(filterValue => {
			if (filterValue.value === undefined || filterValue.value === null || filterValue.value === '') {
				if (firstNullValue === null) {
					firstNullValue = { ...filterValue };
				}
				return false;
			}
			return true;
		});
		let sortedAndFilteredFilterValues = filteredFilterValues.toSorted((a, b) => String(a.value).localeCompare(String(b.value)));
		
		return [ sortedAndFilteredFilterValues, firstNullValue ];
	},[ filterValues ]);


	if (!filterValues || filterValues.length === 0) return (
		<div className='popover-filter-result no-match'>
			Žádné záznamy
		</div>
	);

	return (
		<div className='popover-filter-result'>

			<CheckboxToggleAll
				valuesCheckType={valuesCheckType}
				onClick={onToggleAll} />

			{showAddToFilter &&
				<CheckboxAddToFilter
					addToFilter={addToFilter}
					onClick={onAddToFilter} />}

			{firstNullValue !== null &&
				<FilterResultItem
					filterValue={firstNullValue}
					onToggle={() => onToggle([ null, undefined, ''])} />}
			
			{sortedAndFilteredFilterValues.map(x =>
				<FilterResultItem
					filterValue={x}
					onToggle={onToggle}
					key={`popover-filter-result-item-${x.id}`} />)}
		</div>
	);
};

export default memo(FilterResult);